import LinearProgress from '@mui/material/LinearProgress';
import { FileUploadProgress } from '@partful/shared/lib/hooks/useUploadFile';
import { Typography } from '@partful/shared/ui/Typography';
import { formatDuration, intervalToDuration } from 'date-fns';
import { useTranslation } from 'react-i18next';
import styles from './UploadProgress.module.scss';

type UploadProgressProps = FileUploadProgress & {
  filename: string;
};

export function UploadProgress({ filename, percentage = 0, remainingTime = 0 }: UploadProgressProps) {
  const { t: i18n } = useTranslation();

  const uploadStatusText = formatRemainingTime(remainingTime!)
    ? /* istanbul ignore next */
      i18n('createProduct:cad.uploading', { timeRemaining: formatRemainingTime(remainingTime!) })
    : i18n('createProduct:cad.uploadSuccessful');

  return (
    <div className={styles.uploadProgressContainer}>
      <Typography fontWeight="bold">{filename}</Typography>
      <Typography>{uploadStatusText}</Typography>
      <div className={styles.progressContainer}>
        <LinearProgress variant="determinate" value={percentage} className={styles.progressBar} color="inherit" />
        <Typography>{percentage}%</Typography>
      </div>
    </div>
  );
}

function formatRemainingTime(remainingTime: number) {
  const interval = intervalToDuration({ start: 0, end: remainingTime * 1000 });
  const formattedDuration = formatDuration(interval, {
    format: ['hours', 'minutes', 'seconds'],
    delimiter: ', ',
  });

  return formattedDuration;
}
